import {Article, Contact, Country, Customer, Invoice, Schriftverkehr, Warenpositionen} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Article: Article,
    public Contact: Contact,
    public Country: Country,
    public Customer: Customer,
    public Invoice: Invoice,
    public Schriftverkehr: Schriftverkehr,
    public Warenpositionen: Warenpositionen,
  ) {}
}